<template>
  <div class="calibration_container_single">
    <div class="mgx_top_right_fixed" v-if="calibrating == false">
      <div class="top_right_btn mgx_action_btn ghost" @click="endCalibration">
        <span class="btn_text">{{ $t('end_key_calibration') }}</span>
      </div>
    </div>

    <div class="calibration_container">
      <div class="calibration_text">
        {{ topText }}
      </div>

      <div class="calibration_single_device">
        <Virtual_devices @key-click="selectedKey" v-slot="slotProps">
          <div v-if="calibrationKeys.includes(slotProps.vk)" class="selected"></div>
          <div v-if="selectVKey == slotProps.vk" class="single_cailbration"></div>
        </Virtual_devices>
      </div>
      <div class="calibration_content">{{ $t('calibration_single_tip') }}</div>
    </div>
  </div>
</template>
<script lang="ts"></script>

<script setup lang="ts">
import { calibrationHandler } from '@/service/driver/calibration_set'
import { computed, onUnmounted, ref } from 'vue'
import i18n from '@/languages/i18n'
import { DevicePid, KK, VK } from '@/define/define'
import { kbVKTexture } from '@/define/vkcode'
import { DriverSocketMsg, DriverSocketMsgType } from '@libs/types/message'
import { DriverService } from '@/service/driver/driver'
import { DialogType, enableDialog } from '../cdialog/dialog'
import Virtual_devices from '../device/virtual_devices.vue'
import { DeviceManager } from '@/service/device'

let { t } = i18n.global
// 已校准的按键
const calibrationKeys = ref<VK[]>([])
const successVKey = ref<VK>(-1)
const selectVKey = ref<VK>(-1)
const calibrating = ref(false)
const topText = computed(() => {
  if (selectVKey.value > -1) {
    return t('calibration_press_key', { key: kbVKTexture[selectVKey.value] })
  } else {
    if (successVKey.value > -1) {
      return t('calibration_success_key', { key: kbVKTexture[successVKey.value] }) + '，' + t('calibration_select_key_continue')
    } else {
      return t('calibration_select_key')
    }
  }
})
onUnmounted(() => {
  if (DeviceManager.instance.state.currentPid === DevicePid.None) {
    endCalibration()
  }
})
const endCalibration = async () => {
  calibrationHandler.state.isShowExeSingleCalibration = false
}
const selectedKey = (kk: KK, vk: VK) => {
  if (calibrationKeys.value.includes(vk)) {
    return
  }
  successVKey.value = -1
  calibrating.value = true
  selectVKey.value = vk
  singleCalibration(kk)
}

const singleCalibration = (kk: KK) => {
  const data = {
    Type: DriverSocketMsgType.MTMagnetSingleCalibratin,
    Data: { Key: kk },
  } as DriverSocketMsg<any>
  DriverService.instance.askTypeAndData(data).then(
    () => {
      successVKey.value = selectVKey.value
      selectVKey.value = -1
      calibrationKeys.value.push(successVKey.value)
      calibrating.value = false
    },
    () => {
      enableDialog(t('all_calibration_err'), DialogType.notice, false)
      successVKey.value = -1
      selectVKey.value = -1
      calibrating.value = false
    },
  )
}
</script>

<style scoped lang="less">
.calibration_container_single {
  width: 100%;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.calibration_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .calibration_text {
    margin-bottom: 45px;
    font-size: 20px;
    height: 20px;
    color: #fff;
  }

  .calibration_single_device {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0;

    :deep(.board_view) {
      transform: scale(1.2);
      transform-origin: center;
      background: var(--glass-ghost-bg);
      backdrop-filter: var(--glass-ghost-blur);
      border: 1px solid var(--glass-ghost-border);
      border-radius: var(--radius-l);
      padding: 20px;
    }

    :deep(.texture) {
      color: var(--color-dark) !important;
      font-weight: 700;
      opacity: 1 !important;
    }

    .single_cailbration {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      background: rgba(255, 255, 255, 0.15);
      backdrop-filter: blur(5px);
      color: var(--color-white);
      border-radius: 2px;
      transition: var(--transition-base);
      border: 1px solid rgba(255, 255, 255, 0.2);

      &:hover {
        background: rgba(255, 255, 255, 0.25);
        border-color: var(--color-brand-1);
        z-index: 1;
      }
    }
  }
}

.calibration_content {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: center;
  font-size: 22px;
  margin-top: 80px;
  color: #fffc;
  max-width: 1080px;
}
</style>
